import i18n from 'modules/core/lib/i18n'

type StatusStyle = 'positive' | 'neutral' | 'warning'

type StatusInfo = {
  label: string
  status: StatusStyle
}

export const getPoTemplateVersionStatusInfo = (status: string): StatusInfo => {
  const statusMap: Record<string, StatusInfo> = {
    active: {
      label: i18n.t('procurement.purchase_requests.settings.po_templates.status.active'),
      status: 'positive',
    },
    draft: {
      label: i18n.t('procurement.purchase_requests.settings.po_templates.status.draft'),
      status: 'neutral',
    },
    archived: {
      label: i18n.t('procurement.purchase_requests.settings.po_templates.status.archived'),
      status: 'warning',
    },
  }

  return statusMap[status] ?? { label: '-', status: 'neutral' }
}
